import LoginComponent from '../login-component';
import './form-header.scss';

export default class LoginFormHeader extends LoginComponent {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="login-header">
                <h1 className="title-text">
                    {this.props.title}
                </h1>
                {this.props.subTitle
                    ? (this.props.subTitle)
                    : null
                }
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/form-components/form-header.jsx
 **/